import { Bell, TrendingUp, TrendingDown, Zap, Flame } from 'lucide-react';
import { motion } from 'framer-motion';

const AlertCard = ({ alert, onEdit, onDelete, showActions = true }) => {
  const isTriggered = alert.triggered_at !== null;
  const isGas = alert.energy_type === 'gas';
  const Icon = isGas ? Flame : Zap;

  const getStatusBadge = () => {
    if (!alert.is_active) {
      return <span className="px-2 py-1 text-xs rounded-full bg-[#BFC6CC]/30 text-[#687175]">Inactive</span>;
    }
    if (isTriggered) {
      return (
        <span className={`px-2 py-1 text-xs rounded-full ${
          alert.trigger_type === 'min' ? 'bg-[#10D183]/10 text-[#10D183]' : 'bg-red-50 text-red-500'
        }`}>
          {alert.trigger_type === 'min' ? 'Prix bas atteint' : 'Prix haut atteint'}
        </span>
      );
    }
    return <span className="px-2 py-1 text-xs rounded-full bg-[#397DFF]/10 text-[#397DFF]">Active</span>;
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`bg-white border rounded-xl p-4 md:p-5 transition-all shadow-sm ${
        isTriggered ? 'border-[#397DFF] shadow-md' : 'border-[#BFC6CC]/30'
      }`}
      data-testid={`alert-card-${alert.id}`}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
            isGas ? 'bg-[#397DFF]/10' : 'bg-[#F9C80E]/10'
          }`}>
            <Icon className={`w-5 h-5 ${isGas ? 'text-[#397DFF]' : 'text-[#F9C80E]'}`} />
          </div>
          <div>
            <h4 className="font-bold text-[#191D1E]">{alert.contract_name}</h4>
            <p className="text-sm text-[#687175]">{alert.client_name || 'Client'}</p>
          </div>
        </div>
        {getStatusBadge()}
      </div>

      <div className="grid grid-cols-3 gap-4 mb-4">
        <div>
          <p className="text-xs text-[#687175] mb-1">Prix Min</p>
          <div className="flex items-center gap-1">
            <TrendingDown className="w-4 h-4 text-[#10D183]" />
            <span className="font-mono font-bold text-[#10D183]">{alert.min_price}€</span>
          </div>
        </div>
        <div>
          <p className="text-xs text-[#687175] mb-1">Prix Max</p>
          <div className="flex items-center gap-1">
            <TrendingUp className="w-4 h-4 text-red-500" />
            <span className="font-mono font-bold text-red-500">{alert.max_price}€</span>
          </div>
        </div>
        {alert.current_price && (
          <div>
            <p className="text-xs text-[#687175] mb-1">Prix Actuel</p>
            <span className="font-mono font-bold text-[#191D1E]">{alert.current_price}€</span>
          </div>
        )}
      </div>

      {showActions && (
        <div className="flex gap-2 pt-3 border-t border-[#BFC6CC]/30">
          <button
            onClick={() => onEdit?.(alert)}
            className="flex-1 py-2 text-sm font-medium text-[#687175] hover:text-[#397DFF] hover:bg-[#397DFF]/5 rounded-lg transition-colors"
            data-testid={`edit-alert-${alert.id}`}
          >
            Modifier
          </button>
          <button
            onClick={() => onDelete?.(alert.id)}
            className="flex-1 py-2 text-sm font-medium text-red-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
            data-testid={`delete-alert-${alert.id}`}
          >
            Supprimer
          </button>
        </div>
      )}
    </motion.div>
  );
};

export default AlertCard;
